'use client'

import { FileText } from 'react-feather'
import { useParams, getTranslations } from '@/lib/next-shim'
import { MeetingLinkOrder } from '@/core/graphql/types'
import { useGetTrackedOrderQuery } from '@/core/graphql/hooks'
import { Link } from '@/lib/next-shim'
import { OrderDetails } from './OrderDetails'

export function OrderPage() {
  const params = useParams()
  const referenceId = params?.referenceId as string
  const t = getTranslations()

  const { data, loading, error } = useGetTrackedOrderQuery({
    variables: { referenceId },
    skip: !referenceId,
  })

  if (loading) return <div className="p-10 text-center text-gray-500">{t('common.loading')}</div>
  if (error) return <div className="p-10 text-center text-red-500">{t('common.error', { message: error.message })}</div>

  const trackedOrder = data?.trackedOrder

  if (!trackedOrder) {
    return (
      <div className="mx-auto flex max-w-md flex-col items-center justify-center px-4 py-20 text-center">
        <span className="mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-gray-100 text-gray-400">
          <FileText size={26} aria-hidden="true" />
        </span>
        <h1 className="mb-2 text-2xl font-bold text-gray-900">{t('ui.templates.NotFound.title')}</h1>
        <p className="mb-8 text-gray-500">{t('ui.templates.NotFound.subtitle')}</p>
        <Link
          href="/account/orders"
          className="inline-flex items-center justify-center rounded-full bg-primary px-5 py-2.5 text-sm font-medium text-white transition-colors hover:bg-primary/90"
        >
          {t('account.sections.Orders.title')}
        </Link>
      </div>
    )
  }

  const order = trackedOrder as MeetingLinkOrder

  return (
    <div className="flex flex-1 flex-col">
      <OrderDetails
        order={order}
        referenceId={referenceId}
        ordersSectionTitle={t('account.sections.Orders.title')}
        filesLabel={t('account.cards.files.label')}
        cancelButtonLabel={t('button.cancel.label')}
      />
    </div>
  )
}
